module.exports = __webpack_public_path__ + "img/24.a676a0c0.jpg";